<template>
  <div
    class="benefit"
    v-click-outside="hide"
  >
    <div
      class="benefit__header"
      @click="toggle"
    >
      <div class="benefit__icon">
        <img :src="icon" />
      </div>
      <div class="benefit__title">
        {{ title }}
      </div>
    </div>

    <div
      class="benefit__content"
      :class="{ 'benefit__content--selected': isOpen }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'Benefit',
  props: {
    icon: {
      type: [String, null],
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    const isOpen = ref(false)

    const toggle = () => {
      isOpen.value = !isOpen.value
    }

    const hide = () => {
      isOpen.value = false
    }

    return { isOpen, toggle, hide }
  },
})
</script>
